import $ from 'jquery';
import CFAJAXHandler from '../cf-ajax-handler/CFAJAXHandler';
import DEFAULTS from './defaults';

const NAMESPACE = 'ajaxForm';

class AjaxForm {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend(true, {}, DEFAULTS, options, this.$element.data());

    this.namespace = this.options.namespace;

    this.$element.addClass(this.namespace);

    this.trigger('beforeInit');

    this.initAjaxFormOnSubmitEvent();
    this.initAjaxFormButtonsOnSubmitEvent();
    this.initAjaxFormElementsOnChangeEvent();

    this.trigger('afterInit');
  }

  initAjaxFormOnSubmitEvent() {
    this.$element.on('submit', (events) => {
      events.preventDefault();

      const CFAJAXHandlerInstance = new CFAJAXHandler({
        ajaxUrl: this.options.ajaxUrl,
        data: this.$element.serialize(),
        loaderContainer: this.$element,
        onComplete: (data) => {
          // Initialize defaults for the message and status.
          let textMessage = '';
          let status = 'error';

          if (typeof data === 'string' || data instanceof String) {
            // If the data is a string, get the message directly from it.
            textMessage = data;
          } else if (data.message) {
            // If the data is an object, get the message from the message property.
            textMessage = data.message;
          }

          if (data.status) {
            // If the data is an object, get the status from the status property,
            // otherwise it's set to a default value.
            status = data.status;
          }

          if (textMessage) {
            // Initialize default values for the message class and form group class.
            let messageClass = '';
            let formGroupClass = '';

            if (status === 'error') {
              messageClass = 'text-danger';
              formGroupClass = 'has-error';
            }

            // Add message to this.$element.
            this.addMessageToForm(textMessage, messageClass);

            // Update form group class.
            this.$element.find('.form-group').attr('class', `form-group ${formGroupClass}`);
          } else {
            // Hide message if empty.
            this.hideFormMessage();
          }
        },
      });

      CFAJAXHandlerInstance.resolve();
    });
  }

  initAjaxFormButtonsOnSubmitEvent() {
    this.$element.on('click', 'button[type="submit"],input[type="submit"]', (events) => {
      events.preventDefault();

      const button = $(events.currentTarget);
      const name = button.attr('name');
      const value = button.val();

      // If the name is not defined, just submit the form straight away.
      if (name === undefined) {
        this.$element.submit();
        return;
      }

      const input = $('<input>').attr({
        type: 'hidden',
        name,
      }).val(value);

      this.$element.append(input);
      this.$element.submit();
      input.remove();
    });
  }

  initAjaxFormElementsOnChangeEvent() {
    this.$element.on('change', '.js-cf-submit-on-change', () => {
      this.$element.submit();
    });
  }

  /**
   * Add message to this.$element.
   *
   * @param {string} Text message.
   * @param {string} Message container class.
   */
  addMessageToForm(message, messageClass) {
    // Get any previously attache message container.
    let messageElement = this.$element.find('.message');

    if (!messageElement.length) {
      // Create and prepend message container.
      messageElement = $('<p class="message"></p>');
      this.$element.prepend(messageElement);
    }

    messageElement.html(message).attr('class', `message ${messageClass}`);
  }

  /**
   * Hide message from this.$element.
   */
  hideFormMessage() {
    this.$element.find('.message').addClass('d-none');
  }

  trigger(eventType, ...params) {
    const data = [this].concat(params);

    // Event.
    this.$element.trigger(`${NAMESPACE}::${eventType}`, data);

    // Callback name - allow only words, capitalize event type string and prepend the 'on' string,
    const onFunction = `on${eventType.replace(/\b\w+\b/g, word => word.substring(0, 1).toUpperCase() + word.substring(1))}`;

    if (typeof this.options[onFunction] === 'function') {
      this.options[onFunction].apply(this, params);
    }
  }

  destroy() {
    this.$element.data(NAMESPACE, null);
    this.trigger('destroy');
  }

  static setDefaults(options) {
    $.extend(true, DEFAULTS, $.isPlainObject(options) && options);
  }
}

export default AjaxForm;



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-form/AjaxForm.js